import { render } from "./FilterStats.vue?vue&type=template&id=56561e57"
import script from "./FilterStats.vue?vue&type=script&lang=js"
export * from "./FilterStats.vue?vue&type=script&lang=js"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__